(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('REFRESHING_TIME_FOR_LAST_PAYMENT', 5000);
})();
